import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendMessage = async ({ message, chatRoomId }: { message: string; chatRoomId: string }) => {
  const response = await mutationExecute({
    variables: {
      message,
      chatRoomId,
    },
    mutation: graphql(`
      mutation SendMessage($message: String!, $chatRoomId: String!) {
        sendMessage(message: $message, chatRoomId: $chatRoomId) {
          id
          chatRoomId
          fromNumber
          message
          isRead
          createdAt
          updatedAt
        }
      }
    `),
  });

  return response.data?.sendMessage;
};
